import { render } from "./ContentDeposito.vue?vue&type=template&id=2d2e65a6&scoped=true"
import script from "./ContentDeposito.vue?vue&type=script&lang=js"
export * from "./ContentDeposito.vue?vue&type=script&lang=js"

import "./ContentDeposito.vue?vue&type=style&index=0&id=2d2e65a6&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2e65a6"]])

export default __exports__